export const UserApi = {
    login: '/api/user/basic/base/login',
    getUserInfo: "/api/user/basic/token/userinfo",
    getAccountRegist: "/api/user/basic/base/regist",
    getAccountForget: "/api/user/basic/forget/password",
    getAccountEmailCode: "/api/user/basic/send/email/code",
    // 谷歌登录
    getAccountGoogleLogin: "/api/user/basic/google/callback/code",
    // 三方linuxDo登录
    getAccountLiunxDoLogin: "/api/user/basic/linuxdo/callback/code",
    getAccountAppleLogin: "/api/user/basic/apple/get/token",
    getWxauthUrlApi: "/api/user/basic/wxauth/get/url",  //获取微信二维码地址
    getWxauthCodeLoginApi: "/api/user/basic/wxauth/code/login",  //通过微信code获取用户登录信息
    getQQauthCodeLoginApi: "/api/user/basic/qqauth/code/login",  //通过QQcode获取用户登录信息
    gettWitterCodeLoginApi: "/api/user/basic/twitter/oauth/login",  //通过twitter获取用户登录信息
    getTwitterOauthUrlApi: "/api/user/basic/twitter/oauth/url",  //获取twitter 授权地址
    getFacebookOauthlogin: "/api/user/basic/facebook/oauth/login",  //获取facebook 授权地址
    getLogout: "/api/user/basic/token/userinfo",  //退出登录
    getRequestConfigById: "/api/user/config/get",  //获取配置信息
    getModifyCompareCfgApi: "/api/user/basic/modify/compare/cfg",  //修改用户的“翻译对比文件样式”设置
    getAccountInfoEdit: "/api/user/basic/modify/userinfo",  //修改用户信息
    getDeleteAccount: "/api/user/basic/delete/self"  //删除用户信息

}
export const BasicApi = {
    getHomePageConfig: '/api/user/config/homepage',
    getRoleRights: '/api/user/basic/get/vip/functions',
    getLocalLanguage: '/api/user/language/config/clientGetLanguageConfig',
    getLanguages: '/api/core/pdf/lang/list',
    getEnterpriseConfig: '/api/user/biz/get/service/functions', // 获取企业权益
    getCurrentLocation: '/api/ip/location', // 获取当前位置
    getRequestSensitiveWords: '/api/user/sentitive/get' // 获取敏感词
}
export const TranslateApi = {
    getTranslateResult: '/api/core/pdf/file/upload',
    getOperateRecordId: '/api/user/operate/record/get',
    getRequestCheckFileMD5: '/api/core/pdf/check/same/md5',
    getTranslate: '/api/core/pdf/translate',
    getTranslateCheckStatus: '/api/core/pdf/query/status',
    getEngines: '/api/core/pdf/engines',
    getLastTranslateConfigApi: "/api/core/pdf/get/last/trans/param", //最近一次翻译参数记录；
    getCancelTranslateEstimateApi: '/api/core/pdf/cancel/estimate', // 取消翻译：实时估算阶段与费用
    postCancelTranslateConfirmApi: '/api/core/pdf/cancel/confirm' // 取消翻译：确认取消
}

// 工作台高级设置使用的自定义提示词配置，与 C 端共用同一套接口。
export const PromptApi = {
    getCustomPromptConfig: '/api/core/prompt/clientgetprompt',
    addUserSuggestionPrompt: '/api/core/prompt/addusersuggestionprompt'
}

export const TermApi = {
    getCreateTerm: "/api/user/term/addterm",  // 添加术语库
    getUserTermlist: "/api/user/term/pctermlist", // 查看用户术语库列表
    getUserSearchTermlist: "/api/user/term/termlist", // 查看用户术语库搜索列表
    getDeleteTerm: "/api/user/term/deleteterms", // 删除术语库
    getEditTerm: "/api/user/term/editterm", // 编辑术语库(重命名)
    getTermentrylist: "/api/user/term/gettermentrylist", // 查看用户术语库词条列表
    getAddTermentry: "/api/user/term/addentry", // 添加词条
    getDeleteTermentry: "/api/user/term/deleteentrys", // 删除词条
    getEditTermentry: "/api/user/term/editentry", // 编辑词条
    getTermImportentry: "/api/user/term/importentry", // 导入词库
    getTermImportterm: "/api/user/term/importterm", // 导入术语库
    getCheckTermName: "/api/user/term/checktermnameexit", // 检查术语库名称是否存在,true是存在
    getCheckTermKeyName: "/api/user/term/checkentrykeyexit", // 检查术语库的词条key是否存在,true是存在
    getExportExcelTerm: "/api/user/term/exceltermentrylist", // 根据术语库id导出词库
    getArtInfos: "/api/user/operate/record/termuselog", // 查询当前files下使用的术语
    getPresetTermList: "/api/user/term/preset/list", // 官方术语库列表
    getPresetTermEntryList: "/api/user/term/preset/entrylist", // 官方术语库词条预览
    getPresetTermImport: "/api/user/term/preset/import", // 导入官方术语库
}

export const ProApi = {
    getProConfig: "/api/user/biz/all/price/cfg", // 查询价格
    getBuyTranslateTrade: "/api/user/trade/save", // 用户购买服务【会员or加油包】（生成“交易订单”）
    getTradeOrder: "/api/user/trade/get", // 查询订单支付及权益处理状态
    // 查询支付状态
    getStripePayStatus: "/api/user/stripe/session/pay/status",
    // 检测paypal支付
    getCheckPayPalStatus: "/api/user/paypal/query/order"
}

export const GlobalBizApi = {
    eligibility: "/api/user/global-biz/eligibility",
    contract: "/api/user/global-biz/contract",
    pendingContract: "/api/user/global-biz/pending-contract",
    issueVerification: "/api/user/global-biz/verification/issue",
    confirmVerification: "/api/user/global-biz/verification/confirm",
    remotePreflight: "/api/user/global-biz/remote/preflight",
    prepareBinding: "/api/user/global-biz/binding/prepare",
    members: "/api/user/global-biz/members",
    addMember: "/api/user/global-biz/members/add",
    editMember: "/api/user/global-biz/members/edit",
    removeMember: "/api/user/global-biz/members/remove",
    allocate: "/api/user/global-biz/allocation",
    pendingFuel: "/api/user/global-biz/fuel/pending",
    allocateFuel: "/api/user/global-biz/fuel/allocation",
}

export const AccountRecordApi = {
    getTranslateRecordList: '/api/user/operate/record/list/page',
    getOrderNoList: '/api/user/trade/list',
    createAccountEnterprise: '/api/user/biz/create', // 创建企业
    getEnterpriseInfo: '/api/user/biz/get', // 获取企业信息
    joinEnterprise: '/api/user/biz/member/confirm', // 加入团队
    getEnterpriseMemberList: '/api/user/biz/get/members', // 查询企业成员列表
    addMember: '/api/user/biz/add/member', // 添加成员
    getEnterpriseInviteLinks: '/api/user/biz/invite-links', // 获取企业成员邀请链接
    getEnterpriseWebSites: '/api/user/biz/web-sites', // 企业统一 Web 站点地址
    regenerateEnterpriseInviteLink: '/api/user/biz/invite-link/regenerate', // 重新生成企业成员邀请链接
    createEnterpriseTargetInvite: '/api/user/biz/invite-link/email', // 生成绑定邮箱与空间的定向邀请
    revokeEnterpriseTargetInvite: '/api/user/biz/invite-link/revoke', // 撤销定向邀请
    removeEnterpriseTargetInvite: '/api/user/biz/invite-link/remove', // 删除已过期的定向邀请记录
    acceptEnterpriseInviteLink: '/api/user/biz/invite-link/accept', // 通过邀请链接加入企业
    editMember: '/api/user/biz/edit/member', // 编辑成员
    getBalanceAlert: '/api/user/biz/balance-alert', // 企业低余额预警配置与当前状态
    saveBalanceAlert: '/api/user/biz/balance-alert', // 保存企业低余额预警配置
    dismissBalanceAlert: '/api/user/biz/balance-alert/dismiss', // 关闭当前低余额预警周期
    getPrioritySupportConfig: '/api/user/config/priority-support', // 企业专属客服渠道配置
    deleteMember: '/api/user/biz/del/member', // 删除成员
    deleteFile: '/api/user/operate/record/del', // 删除文件
    deleteFiles: '/api/user/operate/record/delete/ids', // 批量删除文件
    deleteEnterprise: '/api/user/biz/del', // 解散企业
    quitEnterprise: '/api/user/biz/member/quit' // 退出企业
}

export const AccountArtApi = {
    getCreateTerm: "/api/user/term/addterm", // 添加术语库
    getUserTermlist: "/api/user/term/pctermlist", // 查看用户术语库列表
    getUserSearchTermlist: "/api/user/term/termlist", // 查看用户术语库搜索列表
    getDeleteTerm: "/api/user/term/deleteterms", // 删除术语库
    getEditTerm: "/api/user/term/editterm", // 编辑术语库(重命名)
    getTermentrylist: "/api/user/term/gettermentrylist", // 查看用户术语库词条列表
    getAddTermentry: "/api/user/term/addentry", // 添加词条
    getDeleteTermentry: "/api/user/term/deleteentrys", // 删除词条
    getEditTermentry: "/api/user/term/editentry", // 编辑词条
    getTermImportentry: "/api/user/term/importentry", // 导入词库
    getTermImportterm: "/api/user/term/importterm", // 导入术语库
    getCheckTermName: "/api/user/term/checktermnameexit", // 检查术语库名称是否存在,true是存在
    getCheckTermKeyName: "/api/user/term/checkentrykeyexit", // 检查术语库的词条key是否存在,true是存在
    getExportExcelTerm: "/api/user/term/exceltermentrylist", // 根据术语库id导出词库
    getArtInfos: "/api/user/operate/record/termuselog", // 查询当前files下使用的术语
    getAccountFileCompare: "/api/user/operate/record/compare", // 根据id查询“源文件”和“操作后”的文件名
    getPresetTermList: "/api/user/term/preset/list", // 官方术语库列表
    getPresetTermEntryList: "/api/user/term/preset/entrylist", // 官方术语库词条预览
    getPresetTermImport: "/api/user/term/preset/import", // 导入官方术语库
}

export const TranslatePageApi = {
    getAwsUploadFileUrl: "/api/core/tools/get/aws/upload/url",     // 获取AWS亚马逊上传文件的地址URL
    getForwordPythonApi: "/api/core/tools/forword/python", // 转发到python的api接口，提交编辑后的相关数据
    rectangleUploadJsonData: "/api/core/pdf/save/no/trans", // 区域重新翻译逻辑
    retransUploadJsonData: "/api/core/pdf/save/retrans", // 区域重绘：提交保护区域并重新生成译文
    // 【NEW】前端预上传文件到aws（获取aws上传地址）
    getAwsUploadFileUrlApi: "/api/core/pdf/trans/aws/pre/upload",
    // 【NEW】上传“待翻译”的pdf文件
    getAwsUploadFileApi: "/api/core/pdf/file/new/upload"
}

export const TranslateEditApi = {
    getTranslateTextAreaApi: "/api/core/pdf/trans/text/area",  //编辑弹窗，确认翻译引擎调用接口
    getTranslateEditTransApi: "/api/core/pdf/save/edit/trans",  //编辑弹窗，点击重新翻译，写入数据库，然后完成翻译
    getIncrChoiceWordsStatApi: "/api/core/pdf/incr/choice/words/stat",  //划词操作统计
    getIncrOnlineEditStatApi: "/api/core/pdf/incr/online/edit/stat"  //编辑操作统计
}

export const AITranslateApi = {
    // 对比ai
    getAIChatMessage: "/api/core/ai/chat/message/list",
    getAIOpenChatMessageList: "/api/core/ai/chat/open",
    sendAIChatMessage: "/api/ai/chat/ask",
    deleteAIChatMessage: "/api/core/ai/chat/message",
    getAIChatEngines: "/api/core/ai/chat/engines",
    getGenerateMindmap: "/api/core/ai/chat/generate/mindmap",
    getAIChatReloadMessage: "/api/core/ai/chat/message/reload",

    // 文本翻译
    getAITranslateSendApi: "/api/core/ai/translate/askstream",  //ai翻译接口
    getAITranslateDeleteHistoryApi: "/api/core/ai/translate/delete/chat/ids" , //批量删除ai 对话
    getAITranslateListHistoryApi: "/api/core/ai/translate/list",  //获取用户全部的Ai翻译聊天框记录
    getAITranslateChatMessagesApi: "/api/core/ai/translate/message/list",  //查询AI翻译消息记录列表
    getAITranslateClearChatApi: "/api/core/ai/translate/clean/messages",  //用户清空某个Ai翻译的会话
    getAITranslateEditChatNameApi: "/api/core/ai/translate/modify/chat/name",  //修改Ai翻译的聊天框名字
    getOperateRecordDeleteApi: "/api/user/operate/record/delete/ids",  //操作记录批量删除

    // ai 校对
    getAiProofreadingApi: "/api/core/pdf/todo/ai/check",  //ai校对接口
    getAiProofreadingCheckStatus: "/api/core/pdf/query/ai/check/status",  //ai校对状态查询
    getCacheAiProofreadingCheck: "/api/core/pdf/ai/check/page/cache",  //ai校缓存
    getAiProofreadingWritePdfApi: "/api/core/pdf/ai/check/file/write",  //ai校对写入pdf文档
    getAiProofreadingWritePdfStatus: "/api/core/pdf/ai/check/write/status",  //轮询查询介入状态
    getAiProofreadingGetPageContent: "/api/core/pdf/compute/tokens",  //根据文本内容，计算token数量

    // ai下载接口
    getAiChatDownloadFiles: "/api/core/ai/chat/download/message/file",
    getAiChatDownloadState: "/api/core/ai/chat/query/message/file"
}
export const LegacyEnterpriseApi = {
    workspaceSummary: '/api/user/legacy-enterprise/workspace-summary',
    memberStatus: '/api/user/legacy-enterprise/members/status',
    touchState: '/api/user/legacy-enterprise/touch/state',
    visit: '/api/user/legacy-enterprise/touch/visit',
    defer: '/api/user/legacy-enterprise/touch/defer',
    invite: '/api/user/legacy-enterprise/invite',
    state: '/api/user/legacy-enterprise/state',
    begin: '/api/user/legacy-enterprise/begin',
    preflight: '/api/user/legacy-enterprise/preflight',
    execute: '/api/user/legacy-enterprise/execute',
    execution: '/api/user/legacy-enterprise/execution',
    cancelWaiting: '/api/user/legacy-enterprise/cancel-waiting',
    bindIssue: '/api/user/legacy-enterprise/identity/bind/issue',
    bindConfirm: '/api/user/legacy-enterprise/identity/bind/confirm',
}
